import type { NativeBridge } from "./bridge";
import type { BridgeEvents } from "./bridgeEvents";

export class BrowserBridge implements NativeBridge {
  async call<K extends keyof BridgeEvents>(
    event: K,
    _payload?: BridgeEvents[K]["payload"],
  ): Promise<BridgeEvents[K]["response"]> {
    throw new Error(`Method not implemented ${event}`);
  }
  on<K extends keyof BridgeEvents>(_event: K, _callback: (data: BridgeEvents[K]["response"]) => void): void {
    throw new Error("Method not implemented.");
  }
  off<K extends keyof BridgeEvents>(_event: K): void {
    throw new Error("Method not implemented.");
  }
}
